import { Link } from "react-router-dom";

const FooterLogo = (props) => (
    <svg
      width={139}
      height={139}
      viewBox="0 0 139 139"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 2C46.9086 2 29 20.5025 29 43.3265V95.6735C29 118.497 46.9086 137 69 137C90.1953 137 107.54 119.968 108.913 98.4286H61V90.1633H109V73.6327H61V65.3673H109V48.8367H61V40.5714H108.913C107.54 19.032 90.1953 2 69 2Z"
        fill="#ffffff"
      />
    </svg>
  );

  
export default function FooterNew() {
    return (
      <>
        <div className="footer-site">
          <div className="inner">
            <div className="footer-links">
  
              <div className="col">
  
                <ul>
                  <li>
                    <b>Latest</b>
                  </li>
                  <li>
                    <a href="#">
                      <span>AI Integration</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Tech reviews</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Help resources</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Web3</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Design trends</span>
                    </a>
                  </li>
                </ul>
  
                <ul>
                  <li>
                    <b>Web services</b>
                  </li>
                  <li>
                    <a href="/services/portfolio_website">
                      <span>Portfolio website</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/custom_website">
                      <span>Custom website</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/ecommerce">
                      <span>Ecommerce website</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/shopify_website">
                      <span>Shopify website</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/wordpress_website">
                      <span>Wordpress website</span>
                    </a>
                  </li>
                </ul>
  
                <ul>
                  <li>
                    <b>Web & UI design</b>
                  </li>
                  {/* <li>
                    <a href="/services/startup_design">
                      <span>Startup service design</span>
                    </a>
                  </li> */}
                  <li>
                    <a href="/services/modern_layout">
                      <span>Modern design</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/colors_guide">
                      <span>Colors guide</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/figma">
                      <span>Figma</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/adobe_xd">
                      <span>Adobe XD</span>
                    </a>
                  </li>
                </ul>
  
                <ul>
                  <li>
                    <b>Custom development</b>
                  </li>
                  <li>
                    <a href="/services/startup_idea">
                      <span>New startup Idea</span>
                      {/* Your idea our work */}
                    </a>
                  </li>
                  <li>
                    <a href="/services/custom_website">
                      <span>Custom website</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/mobile_development">
                      <span>Custom mobile app</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/desktop_development">
                      <span>Custom desktop app</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/cross_development">
                      <span>Cross-Platform app</span>
                    </a>
                  </li>
                </ul>
  
              </div>
  
              <div className="col">
  
  
                <ul>
                  <li>
                    <b>Resources</b>
                  </li>
                  <li>
                    <a href="https://blog.equibre.com" target="_blank">
                      <span>Ideas to reality - how?</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://blog.equibre.com" target="_blank">
                      <span>Blog</span>
                    </a>
                  </li>
                  <li>
                    <a href="/resources/portfolio">
                      <span>Portfolio</span>
                    </a>
                  </li>
                  <li>
                    <a href="/resources/brochure">
                      <span>Brochure</span>
                    </a>
                  </li>
                </ul>
  
                <ul>
                  <li>
                    <b>Solutions</b>
                  </li>
                  <li>
                    <a href="/solutions/web_development">
                      <span>Web development</span>
                    </a>
                  </li>
                  <li>
                    <a href="/solutions/hosting">
                      <span>Hosting</span>
                    </a>
                  </li>
                  <li>
                    <a href="/solutions/domains">
                      <span>Domains</span>
                    </a>
                  </li>
                  <li>
                    <a href="/solutions/seo">
                      <span>Search optimization</span>
                    </a>
                  </li>
                  <li>
                    <a href="/solutions/payments">
                      <span>Payments</span>
                    </a>
                  </li>
                </ul>
                <ul>
                  <li>
                    <b>Payment & AI Integrations</b>
                  </li>
                  <li>
                    <a href="/services/openai_integration">
                      <span>OpenAI integration</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/claude_integration">
                      <span>Claude integration</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/stripe_integration">
                      <span>Stripe integration</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/paypal_integration">
                      <span>Paypal integration</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/payu_integration">
                      <span>PayU integration</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services/razorpay_integration">
                      <span>RazorPay integration</span>
                    </a>
                  </li>
                </ul>
  
  
                <ul>
                  <li>
                    <b>This</b>
                  </li>
                  <li>
                    <a href="/career">
                      <span>Career</span>
                    </a>
                  </li>
                  <li>
                    <a href="/partnership">
                      <span>Partnership</span>
                    </a>
                  </li>
                  <li>
                    <a href="/about">
                      <span>About & Contact</span>
                    </a>
                  </li>
                  {/* <li>
                    <a href="/contact">
                      <span>Contact</span>
                    </a>
                  </li> */}
                  <li>
                    <a href="/privacy">
                      <span>Privacy policy</span>
                    </a>
                  </li>
                  <li>
                    <a href="/terms">
                      {/* see rvweb/disclaimer */}
                      <span>Terms & Disclaimer</span>
                    </a>
                  </li>
                  <li>
                    <a href="/refund">
                      <span>Refund & Cancellation</span>
                    </a>
                  </li>
                </ul>
  
  
              </div>
  
            </div>
            <div className="footer-branding">
              <div className="inner">
                <div className="contact-col">
                  <div className="inner">
                    <span>
                      <b>Email:</b>
                      <span>contact@equibre.com</span>
                    </span>
                    <span>
                      <b>Mobile:</b>
                      <span>+91 (875) 771 4590</span>
                    </span>
                  </div>
                </div>
                <div className="branding-col">
                  <div className="logo">
                    <FooterLogo width={30} height={40} />
                  </div>
                  <div>
                    <span>&copy;&nbsp;Copyright {(new Date()).getFullYear()}&nbsp;&nbsp;</span><span><span className="dot">•</span>&nbsp;&nbsp;Equibre Private Limited</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }